import api from '../http';
import { AxiosResponse } from 'axios';
import { TaskInfo } from '../models/task';


interface IInviteResponse {
    invite_message_id: string
}

export default class TaskService {
    static async get(): Promise<AxiosResponse<TaskInfo>> {
        return await api.get('task');
    };

    static async submit(taskId: string): Promise<AxiosResponse<{}>> {
        return await api.post('task', {task_id: taskId});
    };

    static async invite(): Promise<AxiosResponse<IInviteResponse>> {
        return await api.post('task/invite');
    };
};